import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Heart } from "lucide-react";

import { AuthProvider, useAuth } from "@/lib/AuthContext";
import Login from "@/components/Login";
import NavBar from "@/components/NavBar";
import Hearts from "@/components/Hearts";
import RoseBurst from "@/components/RoseBurst";
import MusicPlayer from "@/components/MusicPlayer";

import HomePage from "@/pages/HomePage";
import GalleryPage from "@/pages/GalleryPage";
import TimelinePage from "@/pages/TimelinePage";
import MessagesPage from "@/pages/MessagesPage";
import LetterPage from "@/pages/LetterPage";
import HerSpacePage from "@/pages/HerSpacePage";
import SurprisePage from "@/pages/SurprisePage";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AppShell() {
  const { isAuthed, checking, burst } = useAuth();

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F0407]">
        <Heart className="w-10 h-10 text-rose-500 animate-pulse" fill="currentColor" />
      </div>
    );
  }

  if (!isAuthed) {
    return (
      <>
        <Toaster theme="dark" position="top-center" />
        <Login />
      </>
    );
  }

  return (
    <div className="App relative grain">
      <Toaster theme="dark" position="top-center" />
      <RoseBurst active={burst} />
      <Hearts count={18} />
      <NavBar />
      <ScrollToTop />
      <main className="relative z-10">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/histoire" element={<TimelinePage />} />
          <Route path="/galerie" element={<GalleryPage />} />
          <Route path="/mots" element={<MessagesPage />} />
          <Route path="/lettre" element={<LetterPage />} />
          <Route path="/ton-espace" element={<HerSpacePage />} />
          <Route path="/surprise" element={<SurprisePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <MusicPlayer />
      <footer className="px-6 md:px-12 lg:px-24 py-12 text-center border-t border-rose-900/40">
        <p className="font-accent text-2xl text-rose-300">Avec tout ♡ — Amor</p>
        <p className="text-rose-200/40 text-xs mt-2 tracking-widest uppercase">Pour toujours</p>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </BrowserRouter>
  );
}
